/** Whether a control should open the book-call popup (explicit flag or label heuristics). */
export function shouldOpenBookCallPopup(
  bookCallPopup: boolean,
  label?: string,
): boolean {
  if (bookCallPopup) {
    return true;
  }
  return label ? isBookCallCtaLabel(label) : false;
}

/** True when a button label should open the book-call popup instead of navigating. */
export function isBookCallCtaLabel(label: string): boolean {
  const normalized = label.trim().toLowerCase();
  if (!normalized) {
    return false;
  }

  if (normalized.includes("discovery call")) {
    return true;
  }

  if (
    normalized.includes("seo") &&
    (normalized.includes("audit") ||
      normalized.includes("analys") ||
      normalized.includes("analysis"))
  ) {
    return true;
  }

  if (normalized.includes("boka") && normalized.includes("seo")) {
    return true;
  }

  if (normalized.includes("book") && normalized.includes("seo")) {
    return true;
  }

  const mentionsCall =
    normalized.includes("call") ||
    normalized.includes("samtal") ||
    normalized.includes("möte");

  const mentionsBook =
    normalized.includes("book") || normalized.startsWith("boka");

  return mentionsCall && mentionsBook;
}
